export class Ic3CustomDrilldownMenuClasses {

    static readonly header = "Ic3CustomDrilldownMenu-header";

    static readonly list = "Ic3CustomDrilldownMenu-list";

    static readonly headerText = "Ic3CustomDrilldownMenu-headerText";

    static readonly back = "Ic3CustomDrilldownMenu-back";

}

export declare type Ic3CustomDrilldownMenuClassesKey = keyof Ic3CustomDrilldownMenuClasses;
